import { Box, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import colors from 'src/styles/equalution/colors';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckIcon from '@mui/icons-material/Check';

interface SupplementDetailsProps {
  features: string[];
}

export const SupplementDetails: FC<SupplementDetailsProps> = ({ features }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (features.length === 0) {
    return null;
  }

  return (
    <>
      {showDetails && (
        <Box
          sx={{
            marginBottom: '8px',
            transition: 'all 0.3s ease-in-out',
            paddingInline: '16px',
          }}>
          <Typography sx={{ fontSize: '14px', marginBottom: '8px' }}>
            Includes:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
            {features.map(feature => (
              <Box
                key={feature}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                }}>
                <CheckIcon
                  sx={{
                    color: colors.SALAD,
                    fontSize: 20,
                    mt: '2px',
                    mr: 1.5,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: 1.5,
                    color: colors.OFF_BLACK,
                  }}>
                  {feature}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      <Box
        onClick={() => setShowDetails(!showDetails)}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          marginBottom: '4px',
          gap: '4px',
        }}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '20px',
          }}>
          {showDetails ? 'See less' : 'See more'}
        </Typography>
        {showDetails ? (
          <KeyboardArrowUpIcon sx={{ fontSize: '20px' }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ fontSize: '20px' }} />
        )}
      </Box>
    </>
  );
};
